import { Component, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { IconComponent } from '../../../../components/icon/icon.component';

@Component({
  selector: 'td-wb-joyride-back-button',
  templateUrl: 'joyride-back-button.component.html',
  styleUrls: ['./joyride-back-button.component.scss'],
  imports: [TranslatePipe, IconComponent]
})
export class JoyrideBackButtonComponent {
  readonly clicked = output<void>();

  onClick(): false {
    this.clicked.emit();
    return false;
  }
}
